var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.71 2.07L2.78 0.15C2.58 -0.05 2.27 -0.05 2.07 0.15L0.15 2.07C-0.05 2.26 -0.05 2.58 0.15 2.78C0.35 2.98 0.66 2.98 0.86 2.78L1.93 1.71V11.5C1.93 11.78 2.15 12 2.43 12C2.71 12 2.93 11.78 2.93 11.5V1.71L4 2.78C4.1 2.88 4.23 2.93 4.35 2.93C4.47 2.93 4.61 2.88 4.7 2.78C4.9 2.58 4.9 2.26 4.71 2.07Z",
    fill: "#0F0F19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.45 9.22C9.25 9.02 8.94 9.02 8.74 9.22L7.67 10.29V0.5C7.67 0.22 7.45 0 7.17 0C6.89 0 6.67 0.22 6.67 0.5V10.29L5.6 9.22C5.4 9.02 5.09 9.02 4.89 9.22C4.69 9.42 4.69 9.73 4.89 9.93L6.82 11.85C6.92 11.95 7.05 12 7.17 12C7.3 12 7.43 11.95 7.52 11.85L9.45 9.93C9.65 9.74 9.65 9.42 9.45 9.22Z",
    fill: "#0F0F19"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortingIcon);
export default __webpack_public_path__ + "static/media/sortingIcon.d857eaaa7a65d5eeb4ff06c00383f8c6.svg";
export { ForwardRef as ReactComponent };